import React from 'react';
import { Container, Box } from '@mui/material';
import Header from './Header';
import Footer from './Footer';

const PageLayout = ({ children }) => (
  <Box
    sx={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      overflow: 'hidden',
    }}
  >
    {/* Background Decorative Elements */}
    <Box
      sx={{
        position: 'fixed',
        top: '10%',
        right: '-5%',
        width: 300,
        height: 300,
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(0, 175, 216, 0.08) 0%, transparent 70%)',
        animation: 'float 12s ease-in-out infinite',
        zIndex: -1,
      }}
    />
    <Box
      sx={{
        position: 'fixed',
        bottom: '20%',
        left: '-10%',
        width: 400,
        height: 400,
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(0, 91, 187, 0.05) 0%, transparent 70%)',
        animation: 'float 15s ease-in-out infinite reverse',
        zIndex: -1,
      }}
    />
    <Box
      sx={{
        position: 'fixed',
        top: '60%',
        right: '20%',
        width: 150,
        height: 150,
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(122, 184, 0, 0.06) 0%, transparent 70%)',
        animation: 'float 10s ease-in-out infinite',
        zIndex: -1,
      }}
    />
    <Box
      sx={{
        position: 'fixed',
        top: '30%',
        left: '15%',
        width: 200,
        height: 200,
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(245, 130, 51, 0.04) 0%, transparent 70%)',
        animation: 'float 18s ease-in-out infinite',
        zIndex: -1,
      }}
    />

    {/* Header */}
    <Header />

    {/* Main Content Area */}
    <Box
      component="main"
      sx={{
        flex: 1,
        position: 'relative',
        zIndex: 1,
      }}
    >
      <Container 
        maxWidth="xl" 
        sx={{ 
          pt: 0,
          pb: 0,
          px: { xs: 2, sm: 3, md: 4 },
          position: 'relative',
        }}
      >
        {/* Content with glass effect backdrop */}
        <Box
          sx={{
            position: 'relative',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: -20,
              left: -20,
              right: -20,
              bottom: -20,
              background: 'rgba(255, 255, 255, 0.02)',
              backdropFilter: 'blur(1px)',
              borderRadius: 6,
              zIndex: -1,
              pointerEvents: 'none',
            }
          }}
        >
          {children}
        </Box>
      </Container>
    </Box>

    {/* Footer */}
    <Footer />

    {/* Global Keyframes for Animations */}
    <Box
      component="style"
      sx={{
        '& @keyframes float': {
          '0%': { transform: 'translateY(0px) rotate(0deg)' },
          '33%': { transform: 'translateY(-20px) rotate(1deg)' },
          '66%': { transform: 'translateY(-10px) rotate(-1deg)' },
          '100%': { transform: 'translateY(0px) rotate(0deg)' },
        },
      }}
    />
  </Box>
);

export default PageLayout; 